<template>
    <div class="search-component search-component-with-filter">

        <search-breadcrumbs-component @closeFilter='closeFilter'/>

        <template v-if="location && location.area_not_found">
            <p class="h1-class">{{ translate.home.areaNotFoundData.descriptionText }}</p>
        </template>

        <template v-if="location && !location.area_not_found">
            <div class="d-flex space-between gap-2">
                <div class="d-grid d-sm-block flex-grow-1 max-w-full">
                    <h1 v-if="location.isCurrentLocation" class="location-h1">{{ translate.home.inMyLocation }}</h1>
                    <h1 v-else-if="location.h1" class="location-h1">
                        <template v-if="locationH1Data.h1Location">
                            {{ locationH1Data.h1Tag }}
                            <span class="location-h1-highlight">{{ locationH1Data.h1Location }}</span>
                        </template>
                        <template v-else>
                            {{ translateH1Tag(location.h1) }}
                        </template>
                    </h1>

                    <p class="d-none d-sm-block mt-2 mb-0" v-if="searchResponse.total" e2e-id="search-results-count">
                        {{ translate.home.filter }}
                        <b>{{ formatResultsTotal(searchResponse.total) }}</b>
                        {{ translate.home.searchResults }}
                    </p>

                    <p class="d-none d-sm-block mt-2 mb-0" v-if="searchResponse.total === 0" e2e-id="search-results-count">
                        {{ translate.home.searchResultsZero }}
                    </p>
                </div>
            </div>

            <StoriesInSearchComponent v-if="showStories" />
        </template>

        <div class="row main-search">
            <div class="col-md-12 justify-content-between main-search--filter-on-mobile">
                <div class="main-search-content" id="close-filter-search">
                    <div class="searchbar-wrapper">
                        <div class="searchbar-label">{{ translate.home.location }}</div>
                        <div class="mobile-search-radius-display d-sm-none"> +{{ searchRadius }}</div>

                        <select class="form-control select2-selection__default" id="searchMain">
                            <option value="1" v-if="location.query" selected>{{ location.query }}</option>
                        </select>

                        <search-no-js-placeholder-component></search-no-js-placeholder-component>

                    </div>
                    <div class="searchRadius" :class="{'searchRadius--with-label': isUkRegion}">
                        <div id="location-toggle"
                             @click="$emit('mobileFilterOpened')"
                             class="d-sm-none searchRadius--mobile-radius">
                            <span>{{ translate.home.radius }}</span>
                            <b>+ {{searchRadius}}</b>
                        </div>
                        <div class="searchbar-label d-none d-sm-block" v-if="isUkRegion">{{ translate.home.radius }}</div>
                        <select class="form-control rounded-0-left" id="radius" @change="setSearchRadius">
                            <option v-for="(description, radius) in locationRadiuses" :value="radius"
                                    :selected="searchRadius == radius">
                                {{ description }}
                            </option>
                        </select>
                    </div>
                </div>

                <button
                        class="filter-btn ml-1 mr-0"
                        id="filter-toggle"
                        @click="$emit('mobileFilterOpened')">{{ translate.home.filter }}
                </button>
            </div>
        </div>

        <error-component
                v-if="currentLocationError"
                :message="translate.home.currentLocationError"
        ></error-component>
    </div>
</template>

<script>
import searchMixin from "@/components/mixins/search/search-mixin";
import userMixin from "../mixins/userMixin";
import translateMixin from "@/components/mixins/translateMixin";
import {fa_bell} from "@/core/constants/icons";
import StoriesInSearchComponent from "@/components/search/partials/stories/StoriesInSearchComponent";
import {shouldShowStories} from "@/core/utils/helpers/seo/seoHelpers";
import {isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        fromMain: true,
        searchVariant: 'searchMain',
        locationRadiuses: getLocationRadiuses(),
        lodash: _,
    }
};

function getLocationRadiuses() {
    if (isUnitedKingdomRegion()) {
        return _.mapValues(constants.search_radius, function (description) {
            return description.replace(' ', '');
        });
    }

    return constants.search_radius;
}

function formatResultsTotal(total) {
    if (_.isNull(total)) {
        return '...';
    }

    if (!isUnitedKingdomRegion() && parseInt(total) === 10000) {
        return '15000+';
    }

    return total;
}

function isUkRegion() {
    return isUnitedKingdomRegion();
}

function locationH1Data() {
    if (!isUnitedKingdomRegion()) {
        return {};
    }

    return this.translateH1TagData(_.get(this, 'location.h1'));
}

function onLocationChange(e) {
    const result = _.get(e, 'params.data.result', {});
    const payload = this.buildLocationPayload(result);

    this.store.commit('setLocation', payload);
    this.store.commit('refreshSearch', true);
}

function setSearchRadius(event) {
    const radius = _.get(event, 'target.value', '20km');
    this.store.commit('setSearchRadius', radius);
    this.store.commit('refreshSearch');
    this.$emit('onSearchClick');
}

function closeFilter() {
    this.$emit('onSearchClick');
}

export default {
    data,
    components: {
        StoriesInSearchComponent,
    },
    mixins: [
        searchMixin,
        userMixin,
        translateMixin,
    ],
    computed: {
        ...mapState([
            'location',
            'searchRadius',
            'searchResponse',
            'regionData',
            'showStoriesCookieSet',
        ]),
        showStories() {
            return shouldShowStories(this.regionData, this.showStoriesCookieSet);
        },
        isUkRegion,
        locationH1Data,
    },
    methods: {
        fa_bell,
        onLocationChange,
        setSearchRadius,
        closeFilter,
        formatResultsTotal
    },
    watch: {
        location() {
            $('#select2-searchMain-container').text(this.location.query);
        }
    }
}
</script>
